import React, { useEffect, useState } from "react";
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid, Tab, Tabs, TextField } from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import { useDispatch, useSelector } from "react-redux";

import { setCompleteTaskButtonEnabled, setReferbackTaskButtonEnabled } from "store/slice/AppSlice";
import ProductInfo from "./ProductInfo";
import CommentMgmt from "./comment/CommentMgmt";
import FieldView2 from "core/components/layout/FieldView2";
import { updateProductInfo } from "components/product/ProductAPI";
import { updateProductObj } from "store/slice/PharmaSlice";

export default function TaskSpaceQApmCheck() {
  const dispatch = useDispatch();
  const { productObj } = useSelector((state) => state.pharmaslice.productDashboard);
  const { taskApiResponse, taskCompleted } = useSelector((state) => state.appslice.wkflow);

  const [tabIndex, setTabIndex] = useState(0);
  const [editDialogOpen, setEditDialogOpen] = useState(false);
  const [batchNumber, setBatchNumber] = useState(productObj.batchnumber || "");
  const [expiryDate, setExpiryDate] = useState(productObj.expirydate ? productObj.expirydate.split("T")[0] : "");
  const [manufDate, setManufDate] = useState(productObj.manufdate ? productObj.manufdate.split("T")[0] : "");

  const editValid = batchNumber.trim() !== "" && expiryDate.trim() !== "" && manufDate.trim() !== "";

  useEffect(() => {
    setBatchNumber(productObj.batchnumber || "");
    setExpiryDate(productObj.expirydate ? productObj.expirydate.split("T")[0] : "");
    setManufDate(productObj.manufdate ? productObj.manufdate.split("T")[0] : "");
  }, [productObj]);

  useEffect(() => {
    dispatch(setReferbackTaskButtonEnabled(true));
    dispatch(setCompleteTaskButtonEnabled(editValid));
  }, [dispatch, editValid]);

  const handleBatchEditOpen = () => {
    setBatchNumber(productObj.batchnumber || "");
    setExpiryDate(productObj.expirydate ? productObj.expirydate.split("T")[0] : "");
    setManufDate(productObj.manufdate ? productObj.manufdate.split("T")[0] : "");
    setEditDialogOpen(true);
  };

  const handleBatchEditCancel = () => {
    setBatchNumber(productObj.batchnumber || "");
    setExpiryDate(productObj.expirydate ? productObj.expirydate.split("T")[0] : "");
    setManufDate(productObj.manufdate ? productObj.manufdate.split("T")[0] : "");
    setEditDialogOpen(false);
  };

  const handleBatchEditSave = () => {
    updateProductInfo(
      productObj.id,
      {
        batchnumber: batchNumber,
        expirydate: expiryDate,
        manufdate: manufDate,
      },
      (response) => {
        dispatch(updateProductObj(response));
        setEditDialogOpen(false);
      },
      (error) => {
        console.log("Error updating batch details:", error);
      }
    );
  };

  return (
    <Grid item lg={12} md={12} sm={12} xs={12}>
      <Grid container sx={{ width: "100%" }}>
        <Grid item lg={4} md={4} sm={12} xs={12}>
          <Box sx={{ borderRadius: 2, minHeight: "75vh", p: 0 }}>
            <Tabs
              value={tabIndex}
              onChange={(_, value) => setTabIndex(value)}
              variant="fullWidth"
              sx={{ borderBottom: 1, borderColor: "divider" }}
            >
              <Tab label="Product Info" />
              <Tab label="Comments" />
            </Tabs>
            <Box>
              {tabIndex === 0 && <ProductInfo maxHeight="70vh" />}
              {tabIndex === 1 && (
                <Box sx={{ p: 2, minHeight: "70vh" }}>
                  <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 1 }}>
                    <CommentMgmt maxHeight="60vh" status={1} />
                  </Box>
                </Box>
              )}
            </Box>
          </Box>
        </Grid>

        <Grid item lg={8} md={8} sm={12} xs={12} sx={{ pt: 2, pl: { lg: 2, md: 2, sm: 0, xs: 0 } }}>
          <Box sx={{ backgroundColor: "white", borderRadius: 2, p: 2 }}>
            <Grid container spacing={2} alignItems="flex-start">
              <Grid item xs={12} md={4}>
                <FieldView2 label="Batch Number" value={productObj.batchnumber || "-"} />
              </Grid>
              <Grid item xs={12} md={4}>
                <FieldView2 label="Manufacturing Date" value={manufDate || "-"} />
              </Grid>
              <Grid item xs={12} md={4}>
                <FieldView2 label="Expiry Date" value={expiryDate || "-"} />
              </Grid>
              <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Button
                  variant="outlined"
                  startIcon={<EditIcon />}
                  onClick={handleBatchEditOpen}
                  disabled={taskCompleted || (taskApiResponse && taskApiResponse.success !== undefined)}
                >
                  Edit Batch Details
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid>

      <Dialog open={editDialogOpen} onClose={handleBatchEditCancel} maxWidth="sm" fullWidth>
        <DialogTitle>Edit Batch Details</DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label="Batch Number"
            type="text"
            fullWidth
            variant="outlined"
            value={batchNumber}
            onChange={(e) => setBatchNumber(e.target.value)}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Manufacturing Date"
            type="date"
            fullWidth
            variant="outlined"
            value={manufDate}
            onChange={(e) => setManufDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ max: new Date().toISOString().split("T")[0] }}
            sx={{ mb: 2 }}
          />
          <TextField
            margin="dense"
            label="Expiry Date"
            type="date"
            fullWidth
            variant="outlined"
            value={expiryDate}
            onChange={(e) => setExpiryDate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            inputProps={{ min: manufDate || new Date().toISOString().split("T")[0] }}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleBatchEditCancel}>Cancel</Button>
          <Button onClick={handleBatchEditSave} disabled={!editValid}>
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </Grid>
  );
}
